export default state => state.address?.deliveryAddressList?.addresses;
